// src/components/VideoCarousel.js
import React, { useState } from 'react';
import Slider from 'react-slick';
import './CarReview.css';

import review1 from "./assets/review-1.jpg";
import review2 from "./assets/review-2.jpg";
import review3 from "./assets/review-3.jpg";
import review4 from "./assets/review-4.jpg";
import review5 from "./assets/review-5.jpg";
import review6 from "./assets/review-6.jpg";
import review7 from "./assets/review-7.jpg";
import review8 from "./assets/review-8.jpg";
import review9 from "./assets/review-9.jpg";
import review10 from "./assets/review-10.jpg";
import review11 from "./assets/review-11.jpg";
import review12 from "./assets/review-12.jpg";
import review13 from "./assets/review-13.jpg";

import review1video from "./assets/review-1.mp4";
import review2video from "./assets/review-2.mp4";
import review3video from "./assets/review-3.mp4";
import review4video from "./assets/review-4.mp4";
import review5video from "./assets/review-5.mp4";
import review6video from "./assets/review-6.mp4";
import review7video from "./assets/review-7.mp4";
import review8video from "./assets/review-8.mp4";
import review9video from "./assets/review-9.mp4";
import review10video from "./assets/review-10.mp4";
import review11video from "./assets/review-11.mp4";
import review12video from "./assets/review-12.mp4";
import review13video from "./assets/review-13.mp4";

// Import country flag images
import jamaicaFlag from "./assets/jamaica.png";
import guyanaFlag from "./assets/guyana.webp";
import caymanFlag from "./assets/cayman-island.png";

const CarReview = () => {
  const [popupVideo, setPopupVideo] = useState(null);

  const reviews = [
    {
      img: review1,
      video: review1video,
      car: "Honda Grace",
      year: "2019",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.8,
      comment: "Another unit from SKC Japan 2019 under grace hybrid."
    },
    {
      img: review2,
      video: review2video,
      car: "Toyota Mark X",
      year: "2015",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.5,
      comment: "Reliable and fun to drive. Great value for money."
    },
    {
      img: review3,
      video: review3video,
      car: "Toyota Hiace",
      year: "2015",
      country: "Guyana",
      flag: guyanaFlag,
      rating: 4.9,
      comment: "Another satisfied client from Guyana"
    },
    {
      img: review4,
      video: review4video,
      car: "Honda Vezel",
      year: "2019",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.7,
      comment: "Another satisfied customer from Jamaica."
    },
    {
      img: review5,
      video: review5video,
      car: "Toyota Blade",
      year: "2010",
      country: "Cayman Islands",
      flag: caymanFlag,
      rating: 4.6,
      comment: "Another Happy customer from Cayman Islands."
    },
    {
      img: review6,
      video: review6video,
      car: "Toyota Rush",
      year: "2012",
      country: "Guyana",
      flag: guyanaFlag,
      rating: 4.9,
      comment: "Happy customer From Guyana."
    },
    {
      img: review7,
      video: review7video,
      car: "Toyota Noah",
      year: "2012",
      country: "Guyana",
      flag: guyanaFlag,
      rating: 4.4,
      comment: "Satisfied customer."
    },
    {
      img: review8,
      video: review8video,
      car: "",
      year: "",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.7,
      comment: "The SKC and Mr. Nandy Rachput. You know. Mr. Rajput, you always pride yourself, you said you when you, you like to satisfy satisfy customers and I'm really satisfied with this unit this morning that I receive recently from you. You know, I'm satisfied with inside, outside with everything you. You have really kept a word when you said that you will deliver all is well with this unit. Watch the inside, you know. I would like to even express gratitude to your supervisor. Mr. Paraachcha, for he is giving you some amount of leverage and support. Even though you said Moma Boss is a star man, you know it, its it shows how it keeps his team together at there. At SKC. I thank you. I thank you so much. Skc and Mr. Na Rapport, especially Mr. Nadine Rapport. Thank you, man, I'm satisfied with this unit."
    },
    {
      img: review9,
      video: review9video,
      car: "Toyota Hiace",
      year: "2015",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.3,
      comment: "All right so this is a 2015 ha that I received from SKC Japan and this sal one. There is this sal person. There is Mr. Nadim Rajput from SKC Japan. Look at this unit. This is how I receive it. 2015 Ha. Very very clean excellent condition. I would always recommend SKC Japan and more so Mr. Nadimachput this unit. Very very clean excellent condition. Look at this this. How it came. Not no clean up i din not touch it yet so this is it. Come with a low mileage. Lovely so Mr the Narium RA but from Eric Japan. Lovely veto. Excellent condition."
    },
    {
      img: review10,
      video: review10video,
      car: "",
      year: "2019",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.6,
      comment: "Ra from Ja Ra Rami on Nice BRO 2019. Cro 50 Rake Well Well well well. Nice Bro. So Bigger of Ra grow A see wash. I wash big grow nice. Ramya Bible."
    },
    {
      img: review11,
      video: review11video,
      car: "",
      year: "",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.8,
      comment: "Mr rajput. I'm driving a Great Four vehicle sent by SKC Japan. I'm so pleased with this unit. I could jump and touch the sky. Yeah, oh'm my guy, you could do good all the time. I like your body. You know your good spirit. Oh, let me make it up, love it."
    },
    {
      img: review12,
      video: review12video,
      car: "",
      year: "",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.5,
      comment: "Get out to everyone. This is Travis Fall from lean. I'm here to show you this wonderful and beautiful that I get from Rajput. This is a HAR. This is a HAR whereby where I cant show you. This is the engine from the vehicle for the vehicle that I get from Rajput. Where this vehicle is beautiful, it's beautiful the way that I'm showing you guys, this vehicle this, the way this vehicle come from Rachput and I would recommend anyone at any time and any day so buy any vehicle that you choose or wish to to buy. If's reliable, he's a man of his war. Anything he say that's actually it. Yeah, that's actually it. So I would advise anyone. Anyone for any part of the world to purchase any vehicle, any vehicle of your choice, any vehicle that you want from Rachbo. He's a man of his words. What he say, that's what you get and he never let you down. So this is Trappist again from Guiana and this vehicle that I purchase or I should say ar from Rashput, from tail all the way till from Japan and the way it is the way it is right now, that's the way I collect it. So I would advise anyone. Were you looking for quality vehicle, good vehicle vejle with the best mileage, the vehicle that come the way, how you see it on the video or on picture. I would advice you. I would recommend that you buy their vehicle or this vehicle or any other vehicle of your choice from Rajput. Thank you again for watching. You can see it's beautiful and this is a hurry. Yeah, just the way you see I saw it online, thats the way come and it come. The lowest mileage, it's like close to brand new, he always give you the best. Yeah."
    },
    {
      img: review13,
      video: review13video,
      car: "Subaru STI",
      year: "2015",
      country: "Jamaica",
      flag: jamaicaFlag,
      rating: 4.2,
      comment: "All right. This is our car at that bar. From SKC Japan is nice. 2015. Saar S Sti Ice Car so you can search on the website, on the Google website skcjapan and make sure you ox far around me. Nice card bro. I big up says Brother. Okay. I' my respect and I even have so many have come in front of as well. I have some vary dumb trucks, some Crowne marksman."
    }
  ];

  const settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    draggable: true,
    pauseOnHover: true,
    infinite: true,
    dots: false,
    arrows: true,
    speed: 1000,
    centerMode: false,
    centerPadding: "0px",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0px"
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "20px"
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "60px"
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "30px",
          dots: false,
          arrows: false
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
          dots: false,
          arrows: false
        }
      }
    ]
  };

  // Function to render star ratings
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="star full">★</span>);
    }

    if (hasHalfStar) {
      stars.push(<span key="half" className="star half">★</span>);
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} className="star empty">★</span>);
    }

    return stars;
  };

  return (
    <main className="main-review allmain">
      <h2 className="carousel-heading">Customer Reviews</h2>
      <p className="carousel-subheading">Hear what our customers around the world are saying about their vehicles</p>
      <div className="containerBox">
        <Slider {...settings}>
          {reviews.map((review, index) => (
            <div className="slidelogo" key={index}>
              <div className="video-card" onClick={() => setPopupVideo(review.video)}>
                <div className="card-image-container">
                  <img src={review.img} alt="Review" />
                  <div className="play-icon">&#9658;</div>
                </div>
                <div className="card-content">
                  {/* Country info row with flag */}
                  <div className="country-info">
                    <span className="country-name">{review.country}</span>
                    <img 
                      src={review.flag} 
                      alt={`${review.country} flag`} 
                      className="country-flag"
                    />
                  </div>
                  
                  <div className="car-details-review">
                    <span className="car-model">{review.car}</span>
                    <span className="car-year">{review.year}</span>
                  </div>
                  
                  <p className="review-comment">{review.comment}</p>
                  
                  <div className="rating">
                    {renderStars(review.rating)}
                    <span className="rating-value">{review.rating}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {popupVideo && (
        <div className="popup" onClick={() => setPopupVideo(null)}>
          <div className="popup-inner" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={() => setPopupVideo(null)}>&times;</span>
            <video className="popup-content" controls autoPlay>
              <source src={popupVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </main>
  );
};

export default CarReview;